import { useEffect, useRef } from 'react';
import { saveGame } from '../utils/saveManager.js';

/**
 * Auto-save hook that saves on day transitions
 * Only saves when transitioning to 'event' phase with a new day
 *
 * @param {Object} game - Current game state
 */
export function useAutoSave(game) {
  const previousDayRef = useRef(null);
  const previousPhaseRef = useRef(null);

  useEffect(() => {
    // Skip on initial mount
    if (previousDayRef.current === null) {
      previousDayRef.current = game.day;
      previousPhaseRef.current = game.phase;
      return;
    }

    // Auto-save conditions:
    // 1. Day has incremented (previousDay < currentDay)
    // 2. Phase is 'event' (start of new day)
    // 3. Game is not over
    const dayIncremented = previousDayRef.current < game.day;
    const isEventPhase = game.phase === 'event';
    const gameActive = !game.gameOver && !game.gameWon;

    if (dayIncremented && isEventPhase && gameActive) {
      console.log('[AutoSave] Saving game at day', game.day);
      saveGame(game);
    }

    // Update refs
    previousDayRef.current = game.day;
    previousPhaseRef.current = game.phase;
  }, [game.day, game.phase, game.gameOver, game.gameWon, game]);
}
